import { createSelector } from '@ngrx/store';

import { LoadingState } from '../../models';
import { selectDecoratorsState } from './decorators.selector';

export const getDecoratorLoading = createSelector(
  selectDecoratorsState,
  ({ initialLoadingState }): LoadingState => initialLoadingState
);

export const getDecoratorLoadingCompleted = createSelector(
  getDecoratorLoading,
  ({ completed }): boolean => completed
);
